var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"align-middle border p-2 bg rounded-1"},[_vm._v(" "+_vm._s(this.$route.params.action)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }